<template>
  <div>
    <b-container fluid>
      <!-- User Interface controls -->
      <b-row>
        <b-col sm="4" md="4" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        small
        stacked="md"
        striped
        hover
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :busy="loading"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <!-- A custom formatted column -->
        <template v-slot:cell(checkin_at)="data">
          {{ getFormatDateTimeDisplay(data.value) }}
        </template>

        <template v-slot:cell(package_type)="data">
          {{ getPackageTypeFull(data.value) }}
        </template>

        <template v-slot:cell(package_duration)="data">
          {{ getPackageDurationFull(data.value) }}
        </template>

        <template v-slot:cell(actions)="row" v-if="0">
          <b-button
            size="sm"
            @click.prevent="cancelCheckin(row.item)"
            class="mr-1"
            variant="secondary"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
      </b-table>
    </b-container>
  </div>
</template>
<script>
import {
  packageTypeFull,
  packageDurationFull,
} from "./../js/utils/datamanip.js";
import { formatDateTimeDisplay } from "./../js/utils/date.js";
export default {
  props: { memberid: Number },
  data() {
    return {
      loading: false,
      loading_remove: false,
      fields: [
        {
          key: "checkin_at",
          label: "Checkin At",
          sortable: true,
          sortDirection: "desc",
        },
        /*{
          key: "description",
          label: "Description",
        },*/
        {
          key: "package_type",
          label: "Package Type",
        },
        {
          key: "package_duration",
          label: "Package Duration",
        },

       /* {
          key: "actions",
          label: "Remove",
        },*/
      ],
      items: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 30,
      pageOptions: [30, 60],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  mounted() {
    this.getCheckinTime();
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    getPackageTypeFull(key) {
      return packageTypeFull[key];
    },
    getPackageDurationFull(key) {
      return packageDurationFull[key];
    },
    async cancelCheckin(item) {
      if (confirm("Do you really want to delete?")) {
        this.loading = true;
        await axios
          .post("/api/members/visitremove", {
            id: item.id,
          })
          .then((response) => {
            //console.log(response.data);
            this.items = response.data.data;
            this.totalRows = this.items.length;
            //console.log(response.data.data);
            this.loading = false;
          });
      }
    },
    async getCheckinTime() {
      this.loading = true;
      await axios
        .get("/api/members/visit/" + this.memberid)
        .then((response) => {
          //console.log(response.data);
          this.items = response.data;
          this.totalRows = this.items.length;
          
          this.loading = false;
        });
    },
    getFormatDateTimeDisplay(date) {
      return formatDateTimeDisplay(date);
    },
    DeleteVisit(id, index) {
      if (confirm("Do you really want to delete?")) {
        axios
          .delete("/api/artist/" + id)
          .then((resp) => {
            this.artists.data.splice(index, 1);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>
